import { Injectable } from '@angular/core';

import { SettingsService } from '../settings/settings.service';
import {ReplaySubject} from "rxjs";

/**
 * A placeholder for a service that retrieves the left hand menu data
 */
@Injectable({
  providedIn: 'root'
})
export class NavigationDataService {
  public navigationLoaded: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  public applications: any[] = [];

  constructor(
    private settingsService: SettingsService
  ) {}

  async init(): Promise<any> {
  }

}
